import { Moment } from 'moment';
import { DateTime } from 'luxon';
import { SpaSimpleProductDTO } from '@api';
import { TimeInput } from '@components/time-input/time-input.component';

export const momentToLocalDateTime = (date: Moment): string => {
  if (!date.isValid()) {
    return '';
  }
  return date.format('YYYY-MM-DDTHH:mm:ss');
};

declare module 'luxon' {
  export interface DateTime {
    toLocalDateTime(): string;
  }
}

DateTime.prototype.toLocalDateTime = function (): string {
  const _self = this as DateTime;
  return _self.toFormat("yyyy-MM-dd'T'HH:mm:ss");
};

export function clampToOpeningHours(
  start: DateTime,
  end: DateTime,
  openingHour = 6,
  closingHour = 23,
): { start: DateTime; end: DateTime } {
  const dayStart = start.startOf('day');
  const openingStart = dayStart.set({ hour: openingHour, minute: 0, second: 0, millisecond: 0 });
  const openingEnd = dayStart.set({ hour: closingHour, minute: 0, second: 0, millisecond: 0 });
  const duration = end.diff(start);

  let clampedStart = start;
  let clampedEnd = end;

  if (clampedStart < openingStart) {
    clampedStart = openingStart;
    clampedEnd = clampedStart.plus(duration);
  }
  if (clampedEnd > openingEnd) {
    clampedEnd = openingEnd;
    clampedStart = clampedEnd.minus(duration);
    if (clampedStart < openingStart) {
      clampedStart = openingStart;
    }
  }

  return { start: clampedStart, end: clampedEnd };
}

export function calculateGuestTimes(
  from: DateTime,
  to: DateTime,
  product: SpaSimpleProductDTO | undefined,
): [startTimeInputGuest: TimeInput, endTimeInputGuest: TimeInput] {
  const preparation = product?.preTreatmentWorkMinutes;
  const postProcessing = product?.postTreatmentWorkMinutes;
  const duration = product?.duration;
  const durationTotal = product?.durationTotal;
  const diffDurationAndDurationTotal = durationTotal != null && duration != null ? durationTotal - duration : undefined;

  const startDateTimeGuest = from.plus({ minutes: preparation });
  const endDateTimeGuest = to.minus({ minutes: postProcessing }).minus({ minutes: diffDurationAndDurationTotal });

  const startTimeInputGuest = {
    hour: startDateTimeGuest.toFormat('HH'),
    minute: startDateTimeGuest.toFormat('mm'),
  };
  const endTimeInputGuest = {
    hour: endDateTimeGuest.toFormat('HH'),
    minute: endDateTimeGuest.toFormat('mm'),
  };

  return [startTimeInputGuest, endTimeInputGuest];
}
